import styled, { css } from "styled-components";
import { useDesignTokens } from "@boi/react-design-tokens";

export const Container = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
`;

type ShadowProps = {
  $visible: boolean;
};

export const Shadow = styled.div<ShadowProps>`
  position: absolute;
  left: 0;
  width: 100%;
  height: 10px;
  transition: transform 0.15s;
  pointer-events: none;
`;

export const TopShadow = styled(Shadow)`
  ${({ $visible }) => {
    const { tokens } = useDesignTokens();
    const { scrollShadowContainer } = tokens;

    return [
      css`
        top: 0;
        transform: translateY(-10px);
        box-shadow: inset 0 7px 9px -7px ${scrollShadowContainer.shadow.color};
      `,
      $visible &&
        css`
          transform: translateY(0px);
        `,
    ];
  }}
`;

export const BottomShadow = styled(Shadow)`
  ${({ $visible }) => {
    const { tokens } = useDesignTokens();
    const { scrollShadowContainer } = tokens;

    return [
      css`
        bottom: 0;
        transform: translateY(10px);
        box-shadow: inset 0 -7px 9px -7px ${scrollShadowContainer.shadow.color};
      `,
      $visible &&
        css`
          transform: translateY(0px);
        `,
    ];
  }}
`;

export const ScrollContainer = styled.div`
  ${() => {
    const {
      tokens: {
        scrollShadowContainer,
        scrollBar: { thumbColor, trackColor },
      },
    } = useDesignTokens();

    return css`
      height: 100%;
      overflow-y: auto;
      scrollbar-color: ${thumbColor} ${trackColor};

      &:focus-visible {
        outline-width: ${scrollShadowContainer.focusRing.width};
        outline-style: ${scrollShadowContainer.focusRing.style};
        outline-color: ${scrollShadowContainer.focusRing.color};
        outline-offset: ${scrollShadowContainer.focusRing.offset};
      }
    `;
  }}
`;
